import { __decorate } from "tslib";
import { singleton } from 'mana-syringe';
import { GeometryAABBUpdater } from './interfaces';
import { Shape } from '../../types';

var CircleUpdater =
/** @class */
function () {
  function CircleUpdater() {}

  CircleUpdater.prototype.update = function (parsedStyle, object) {
    var r = parsedStyle.r,
        _a = parsedStyle.x,
        x = _a === void 0 ? 0 : _a,
        _b = parsedStyle.y,
        y = _b === void 0 ? 0 : _b;
    var unit = r.unit,
        value = r.value;
    var width = 0;
    var height = 0; // absolute unit

    if (unit === '' || unit === 'px') {
      width = value * 2;
      height = value * 2;
    }

    object.parsedStyle.rInPixels = width / 2;
    return {
      width: width,
      height: height,
      x: x,
      y: y
    };
  };

  CircleUpdater = __decorate([singleton({
    token: {
      token: GeometryAABBUpdater,
      named: Shape.CIRCLE
    }
  })], CircleUpdater);
  return CircleUpdater;
}();

export { CircleUpdater };